import { useParams, Link } from "react-router-dom";
import { useState } from "react";

import ExamLevelCard from "../../../../ReusableComponent/ExamLevelCard";
import CertificationInstructions from "../../../../ReusableComponent/CertificationInstructions";

const CertificateDetailPage = () => {
  const { title } = useParams();
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [showInstructions, setShowInstructions] = useState(false);

  // Updated full data per certificate
  const certificateLevels = [
    //js beginner,intermediate,advanced,expert
    {
      technology: "javascript",
      title: "Beginner Level",
      level: "Beginner",
      duration: "45 min",
      questions: 50,
      passPercentage: 70,
      topics: [
        "Variables & Data Types",
        "Functions",
        "DOM Manipulation",
        "Events",
        "Basic ES6",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",

      //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link:"assessment/test/68c4739a58541900049ef17e"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
    {
      technology: "javascript",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "60 min",
      questions: 60,
      passPercentage: 75,
      topics: [
        "Async Programming",
        "Promises",
        "Classes",
        "Modules",
        "Error Handling",
        "ES6+ Features",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link:"assessment/test/68e5664efc6c3a0004e7b797"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
    {
      technology: "javascript",
      title: "Advanced Level",
      level: "Advanced",
      duration: "75 min",
      questions: 70,
      passPercentage: 80,
      topics: [
        "Closures",
        "Prototypes",
        "Performance",
        "Design Patterns",
        "Testing",
        "Node.js Basics",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
      //new
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link:"quiz/test/68e6a15792db3e00045de927"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
    {
      technology: "javascript",
      title: "Expert Level",
      level: "Expert",
      duration: "90 min",
      questions: 80,
      passPercentage: 85,
      topics: [
        "Advanced Async",
        "Memory Management",
        "Security",
        "Metaprogramming",
        "Advanced Testing",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //react beginner,intermediate,advanced
    {
      technology: "React",
      title: "Beginner Level",
      level: "Beginner",
      duration: "50 min",
      questions: 40,
      passPercentage: 70,
      topics: ["Components", "JSX", "Props", "State", "Events"],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "React Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
    {
      technology: "React",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "65 min",
      questions: 50,
      passPercentage: 75,
      topics: ["Hooks", "Context API", "Routing", "Forms", "State Management"],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "React Certification - Intermediate Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link:"assessment/test/68e7f364ed60c500047eaca3"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
    {
      technology: "React",
      title: "Advanced Level",
      level: "Advanced",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "React Certification - Advance Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link:"assessment/test/68e7fd21fa20160004300495"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

     //Vue beginner,intermediate,advanced
    {
      technology: "Vue.js",
      title: "Beginner Level",
      level: "Beginner",
      duration: "50 min",
      questions: 40,
      passPercentage: 70,
      topics: ["Components", "JSX", "Props", "State", "Events"],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Vue.js Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
    {
      technology: "Vue.js",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "65 min",
      questions: 50,
      passPercentage: 75,
      topics: ["Hooks", "Context API", "Routing", "Forms", "State Management"],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Vue.js Certification - Intermediate Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
    {
      technology: "Vue.js",
      title: "Advanced Level",
      level: "Advanced",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Vue.js Certification - Advanced Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //css beginner,intermediate,advanced
     {
      technology: "CSS",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "CSS Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "CSS",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "CSS Certification - Intermediate Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link: "assessment/test/68eff285a10578000406e960"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "CSS",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "CSS Certification - Advanced Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link : "assessment/test/68effc02a6647a0004f49682"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //typescript beginner,intermediate,advanced
      {
      technology: "typescript",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "typescript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link:"assessment/test/68ec0816e827a40004909a92"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "typescript",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "typescript Certification - Intermediate Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "typescript",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "typescript Certification - Advanced Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //html beginner,intermediate,advanced
      {
      technology: "HTML",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "HTML Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "HTML",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "HTML Certification - Intermediate Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "HTML",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "HTML Certification - Advanced Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //Bootstrap beginner,intermediate,advanced
       {
      technology: "Bootstrap",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Bootstrap",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Bootstrap",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //angular beginner,intermediate,advanced
      {
      technology: "Angular",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Angular Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link : "assessment/test/68ec16a74e8cbf00041e493a"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Angular",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Angular",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
    //Node.js beginner,intermediate,advanced
      {
      technology: "Node.js",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Node.js Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link:"assessment/test/6865179a6d34910004109d57"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Node.js",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Node.js Certification - Intermediate Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Node.js",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Node.js Certification - Advanced Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

      //Express.js beginner,intermediate,advanced
      {
      technology: "Express.js",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Express.js Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link:"assessment/test/68ed52fa54a6e50004da847f"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Express.js",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Express.js Certification - Intermediate Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link: "assessment/test/68ed5bffd9269b0004d5889d"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Express.js",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Express.js Certification - Advanced Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link:"assessment/test/68ee940c0448f8000405f59c"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //python beginner,intermediate,advanced
      {
      technology: "Python",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Python Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Python",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Python Certification - Intermediate Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link:"assessment/test/68e81accdff30400042f35d8"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Python",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Python Certification - Advanced Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link :"assessment/test/68ea2dbe846ddf00047b1c90"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //Java beginner,intermediate,advanced
      {
      technology: "Java",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Java Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Java",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Java Certification - Intermediate Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Java",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Java Certification - Advanced Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //C# beginner,intermediate,advanced
      {
      technology: "C#",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "C#",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "C#",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //Go beginner,intermediate,advanced
      {
      technology: "Go",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Go",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Go",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //Ruby beginner,intermediate,advanced
      {
      technology: "Ruby",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Ruby",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Ruby",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //MySQL beginner,intermediate,advanced
      {
      technology: "MySQL",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "MySQL Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "MySQL",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "MySQL Certification - Intermediate Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link : "assessment/test/68ea2dbe846ddf00047b1c90"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "MySQL",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "MySQL Certification - Advance Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link : "assessment/test/68ea3d5da3749c000491fbf2"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //MongoDB beginner,intermediate,advanced
      {
      technology: "MongoDB",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "MongoDB Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link : "assessment/test/68ed3d2e5b31f80004e13bd8"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "MongoDB",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "MongoDB Certification - Intermediate Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link : "assessment/test/68ed41e0ff100600048193cf"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "MongoDB",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //Docker beginner,intermediate,advanced
      {
      technology: "Docker",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Docker",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Docker",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //Kubernetes beginner,intermediate,advanced
      {
      technology: "Kubernetes",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Kubernetes",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Kubernetes",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //AWS beginner,intermediate,advanced
      {
      technology: "AWS",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "AWS",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "AWS",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //Git beginner,intermediate,advanced
      {
      technology: "Git",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Git Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link:"assessment/test/68c513761c042c00043a49a4"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Git",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Git Certification - Intermediate Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
        link : "assessment/test/68eeb117b4fdca0004b53974"
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Git",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "Git Certification - Advance Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //React Native beginner,intermediate,advanced
      {
      technology: "React Native",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "React Native",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "React Native",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //Flutter beginner,intermediate,advanced
      {
      technology: "Flutter",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Flutter",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Flutter",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //Swift beginner,intermediate,advanced
      {
      technology: "Swift",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Swift",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Swift",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //Kotlin beginner,intermediate,advanced
      {
      technology: "Kotlin",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Kotlin",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Kotlin",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },

    //Xamarin beginner,intermediate,advanced
      {
      technology: "Xamarin",
      title: "Beginner Level",
      level: "Beginner",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Xamarin",
      title: "Intermediate Level",
      level: "Intermediate",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
     {
      technology: "Xamarin",
      title: "Advance Level",
      level: "Advance",
      duration: "80 min",
      questions: 60,
      passPercentage: 80,
      topics: [
        "Performance",
        "Testing",
        "Custom Hooks",
        "Advanced Patterns",
        "SSR (Server-Side Rendering)",
      ],
      rating: "4.8",
      certifiedCount: "2.5K",
       //new
      examData: {
        title: "JavaScript Certification - Beginner Level",
        subtitle: "Professional Certification Exam",
        duration: "45 min",
        questions: 50,
        passScore: "70%",
        validity: "1 Year",
        instructions: [
          "You have 45 min to complete 50 questions",
          "Questions include multiple choice, code analysis, and practical scenarios",
          "Minimum 70% score required to pass",
          "Certificate valid for 1 year with industry recognition",
          "No external resources allowed during the exam",
        ],
        topics: [
          "Variables & Data Types",
          "Functions",
          "DOM Manipulation",
          "Events",
          "Basic ES6",
        ],
      },

      benefitsData: {
        title: "Certification Benefits",
        benefits: [
          {
            icon: "🏆",
            heading: "Industry Recognition",
            description: "Earn credentials respected across the industry.",
          },
          {
            icon: "🔗",
            heading: "LinkedIn Badge",
            description: "Showcase your achievement on your LinkedIn profile.",
          },
          {
            icon: "🔒",
            heading: "Blockchain Verified",
            description: "Secure and verifiable digital certificate.",
          },
          {
            icon: "🚀",
            heading: "Career Boost",
            description: "Improve your chances for promotions and new roles.",
          },
        ],
      },

      successStoriesData: {
        title: "Recent Success Stories",
        stories: [
          {
            name: "Sarah K.",
            role: "Frontend Developer",
            feedback: "Got promoted after earning this certificate!",
          },
          {
            name: "Mike R.",
            role: "Full Stack Engineer",
            feedback: "Helped me land my dream job at Google!",
          },
        ],
        footerNote: "Join 50,000+ certified professionals",
      },
    },
  ];

  // filter certificates based on route param
  const filteredLevels = certificateLevels.filter(
    (item) => item.technology.toLowerCase() === title.toLowerCase()
  );

  // find full data of selected level
  const selectedLevelData = filteredLevels.find(
    (item) => item.level === selectedLevel
  );

  return (
    <div className="row mx-0 py-5 d-flex justify-content-center align-items-center text-light">
      <div className="col-md-11 col-12">
        <div className="row mx-0 d-flex justify-content-center align-items-center">
          {!showInstructions ? (
            <>
              <Link to="/certificate" className="text-primary mb-3 d-block">
                ← Back to Certificates
              </Link>
              <div className="col-12 text-center mb-3">
                <h2 className="fw-bold">{title} Certification</h2>
                <p className="text-muted">
                  Master {title} fundamentals and advanced concepts.
                </p>
              </div>
              {/* Render Levels */}
              <div className="row mx-0 mt-4">
                {filteredLevels.map((level, idx) => (
                  <div
                    key={idx}
                    className="col-md-6 mb-4"
                    onClick={() => setSelectedLevel(level.level)}
                  >
                    <ExamLevelCard
                      {...level}
                      isSelected={selectedLevel === level.level}
                    />
                  </div>
                ))}
              </div>
              {/* Show Continue Button only if selected */}
              {selectedLevel && (
                <div className="text-center mt-4">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={() => setShowInstructions(true)}
                  >
                    Continue with {selectedLevel} Level
                  </button>
                  {/* <Button variant="gradient" onClick={() => setShowInstructions(true)}>
                    Continue with {selectedLevel} Level
                  </Button> */}
                </div>
              )}
            </>
          ) : (
            selectedLevelData && (
              <CertificationInstructions
                examData={selectedLevelData.examData}
                benefitsData={selectedLevelData.benefitsData}
                successStoriesData={selectedLevelData.successStoriesData}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default CertificateDetailPage;
